import { Tooltip } from '@qodo/design-system';
import { Database, FolderGit2, Info } from 'lucide-react';
import { spawn } from 'utils/translations';
import { ProjectRowProps } from '../types';
import { SelectionCheckboxRow } from './SelectionCheckboxRow';

export const ProjectRow = ({
  project,
  selectedIds,
  onToggleProjectRepos,
  onToggleRepository,
}: ProjectRowProps) => {
  const spawnStep = spawn('dialogs.azure-installation.steps.connect-repos');

  const projectReposLength = project.repositories.length;
  const allProjectReposUsed =
    projectReposLength > 0 && project.repositories.every((r) => r.isUsed);
  const selectableRepoIds = project.repositories
    .filter((r) => !r.isUsed)
    .map((r) => r.id);
  const allProjectSelected =
    selectableRepoIds.length > 0 &&
    selectableRepoIds.every((id) => selectedIds.has(id));

  const renderProjects = () => {
    if (projectReposLength === 0) {
      return (
        <div className="flex items-center gap-3 py-1.5 px-3">
          <span className="text-sm text-neutral-500">
            {spawnStep('no-repos')}
          </span>
        </div>
      );
    }

    return project.repositories.map((repo) => {
      const isUsed = !!repo.isUsed;

      return (
        <div key={repo.id} className="flex items-center gap-3 py-1.5 group">
          <SelectionCheckboxRow
            name={`azure-repo-${repo.id}`}
            label={repo.name}
            checked={!isUsed && selectedIds.has(repo.id)}
            onCheckedChange={() => !isUsed && onToggleRepository(repo.id)}
            icon={Database}
            disabled={isUsed}
          />
          {isUsed && (
            <Tooltip
              content={spawnStep('repo-already-used')}
              // Trigger override kept: the icon is revealed only on row hover.
              triggerProps={{
                asChild: true,
                className:
                  'opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 cursor-pointer',
              }}
              contentProps={{ side: 'right' }}
            >
              <Info className="size-4 shrink-0 text-text-interactive-neutral-idle" />
            </Tooltip>
          )}
        </div>
      );
    });
  };

  return (
    <div>
      <div className="flex items-center gap-3 py-1.5 px-3 pl-7">
        <SelectionCheckboxRow
          name={`azure-project-${project.projectId}`}
          label={project.name}
          checked={allProjectSelected}
          onCheckedChange={() => onToggleProjectRepos(selectableRepoIds)}
          icon={FolderGit2}
          disabled={allProjectReposUsed}
        />
      </div>
      <div className="ml-14.5 space-y-1 pb-1">{renderProjects()}</div>
    </div>
  );
};
